import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { equals as deepEqual } from 'ramda';
import shallowEqual from 'shallowequal';
import Entanglement from 'react-entanglement';
import { compose, defaultProps, setDisplayName, withHandlers, withProps } from 'recompose';
import omitProps from '@hocs/omit-props';
import { withDesignVersion } from '@bubble-ui/provider-design-version';
import { withDialogOptions } from '@bubble-ui/provider-dialog-options';
import { withDesignContext } from '@klarna/designtokens';
import TrapFocus from 'focus-trap-react';
import IconBackNavigation from '@bubble-ui/icon-back-navigation';
import IconClose from '@bubble-ui/icon-close';
import * as Breakpoints from '@bubble-ui/particle-breakpoints';
import NavBar from '@bubble-ui/molecule-nav-bar';
import ButtonPrimary from '@bubble-ui/molecule-button-primary';
import ButtonSecondary from '@bubble-ui/molecule-button-secondary';
import ButtonTertiary from '@bubble-ui/molecule-button-tertiary';
import ButtonQuaternary from '@bubble-ui/molecule-button-quaternary';
import { isMobileDevice } from '@bubble-ui/util-platform';
import View from '@bubble-ui/primitive-view';
import { Provider as DialogContentWidthProvider } from '@bubble-ui/provider-dialog-content-width';
import DialogIcon from './DialogIcon';
import getDefaultStyleSheet, { getDesktopContentSize } from './getDefaultStyleSheet';
import { CONTAINER_PADDING_TOP_KUZCO, EXTRA_PADDINGS, DESKTOP_ICON_SIZE } from './constants';
import defaultDesignTokens from './defaultDesignTokens';
import Layout from './Layout';

var getNavBarHeight = function getNavBarHeight(hasIconInNavbar, hasTitle, hideHeader) {
  return hideHeader ? 0 : hasIconInNavbar && hasTitle ? CONTAINER_PADDING_TOP_KUZCO + DESKTOP_ICON_SIZE / 2 : CONTAINER_PADDING_TOP_KUZCO;
};

var getIds = function getIds(_ref) {
  var id = _ref.id;
  return {
    ids: id ? {
      root: id,
      outerWrapper: "".concat(id, "__outer-wrapper"),
      innerWrapper: "".concat(id, "__inner-wrapper"),
      navBarWrapper: "".concat(id, "__nav-bar-wrapper"),
      navBar: "".concat(id, "__nav-bar"),
      scrollableArea: "".concat(id, "__scrollable-area"),
      containerWrapper: "".concat(id, "__container-wrapper"),
      container: "".concat(id, "__container"),
      bottom: "".concat(id, "__bottom"),
      backButton: "".concat(id, "__back-button"),
      closeButton: "".concat(id, "__close-button"),
      backgroundClickHandler: "".concat(id, "__background-click-handler"),
      footerButtonWrapper: "".concat(id, "__footer-button-wrapper")
    } : {}
  };
};

var MaterializedButtonPrimary = Entanglement.materialize({
  name: 'ButtonPrimary',
  constructor: ButtonPrimary
});
var MaterializedButtonSecondary = Entanglement.materialize({
  name: 'ButtonSecondary',
  constructor: ButtonSecondary
});
var MaterializedButtonTertiary = Entanglement.materialize({
  name: 'ButtonTertiary',
  constructor: ButtonTertiary
});
var MaterializedButtonQuaternary = Entanglement.materialize({
  name: 'ButtonQuaternary',
  constructor: ButtonQuaternary
});

var Dialog = /*#__PURE__*/function (_Component) {
  _inherits(Dialog, _Component);

  var _super = _createSuper(Dialog);

  function Dialog(props) {
    var _this;

    _classCallCheck(this, Dialog);

    _this = _super.call(this, props);
    _this.adapter = Entanglement.passthroughAdapter();
    _this.state = {
      bottomSize: {
        height: 0
      },
      contentSize: {
        height: 0
      },
      rootSize: {
        height: 0,
        width: 0
      }
    };
    _this.onContentResize = _this.onContentResize.bind(_assertThisInitialized(_this));
    _this.onRootResize = _this.onRootResize.bind(_assertThisInitialized(_this));
    _this.calculateWindowAndResize = _this.calculateWindowAndResize.bind(_assertThisInitialized(_this));

    _this.props.onDialogWillOpen(props);

    return _this;
  }

  _createClass(Dialog, [{
    key: "calculateWindowAndResize",
    value: function calculateWindowAndResize() {
      if (this.bottomDomElement && this.contentDomElement) {
        var contentHeight = Math.floor(this.contentDomElement.getBoundingClientRect().height);
        var bottomHeight = Math.floor(this.bottomDomElement.getBoundingClientRect().height);
        var height = this.contentDomElementDefaultView && Math.floor(this.contentDomElementDefaultView.innerHeight);
        var width = this.contentDomElementDefaultView && Math.floor(this.contentDomElementDefaultView.innerWidth);
        this.setState({
          rootSize: {
            height: height,
            width: width
          },
          contentSize: {
            height: contentHeight
          },
          bottomSize: {
            height: bottomHeight
          }
        });

        if (this.props.onResize) {
          this.props.onResize({
            height: height,
            width: width
          });
        }
      }
    }
  }, {
    key: "onRootResize",
    value: function onRootResize(_ref2) {
      var height = _ref2.height,
          width = _ref2.width;
      var contentHeight = this.contentDomElement.getBoundingClientRect().height;
      var bottomHeight = this.bottomDomElement.getBoundingClientRect().height;
      var rootHeight = this.props.useWindowHeight && this.contentDomElementDefaultView ? Math.floor(this.contentDomElementDefaultView.innerHeight) : Math.floor(height);
      var rootWidth = Math.floor(width);
      this.setState(_objectSpread(_objectSpread({
        rootSize: {
          height: rootHeight,
          width: rootWidth
        }
      }, this.contentDomElement ? {
        contentSize: {
          height: contentHeight
        }
      } : {}), this.bottomDomElement ? {
        bottomSize: {
          height: bottomHeight
        }
      } : {}));

      if (this.props.onResize) {
        this.props.onResize({
          height: rootHeight,
          width: rootWidth
        });
      }
    }
  }, {
    key: "onContentResize",
    value: function onContentResize() {
      if (this.rootDomElement && this.bottomDomElement && this.contentDomElement) {
        var contentHeight = Math.floor(this.contentDomElement.getBoundingClientRect().height);
        var bottomHeight = Math.floor(this.bottomDomElement.getBoundingClientRect().height);
        var rootHeight = Math.floor(this.rootDomElement.getBoundingClientRect().height);
        var rootWidth = Math.floor(this.rootDomElement.getBoundingClientRect().width);
        var realRootHeight = this.props.useWindowHeight && this.contentDomElementDefaultView ? Math.floor(this.contentDomElementDefaultView.innerHeight) : rootHeight;
        this.setState({
          rootSize: {
            height: realRootHeight,
            width: rootWidth
          },
          contentSize: {
            height: contentHeight
          },
          bottomSize: {
            height: bottomHeight
          }
        });
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.onRef) {
        this.props.onRef(this);
      }

      if (this.props.useWindowHeight === true && this.contentDomElementDefaultView) {
        this.contentDomElementDefaultView.addEventListener('resize', this.calculateWindowAndResize);
      }

      this.props.onDialogDidOpen(this.props);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.useWindowHeight === true && prevProps.useWindowHeight !== true && this.contentDomElementDefaultView) {
        this.contentDomElementDefaultView.addEventListener('resize', this.calculateWindowAndResize);
      } else if (this.props.useWindowHeight !== true && prevProps.useWindowHeight === true && this.contentDomElementDefaultView) {
        this.contentDomElementDefaultView.removeEventListener('resize', this.calculateWindowAndResize);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.onRef) {
        this.props.onRef(undefined);
      }

      this.props.onDialogWillClose(this.props);

      if (this.contentDomElementDefaultView) {
        this.contentDomElementDefaultView.removeEventListener('resize', this.calculateWindowAndResize);
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !deepEqual(nextState, this.state) || !shallowEqual(nextProps, this.props);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          _this$props$backgroun = _this$props.backgroundColorToken,
          backgroundColorToken = _this$props$backgroun === void 0 ? 'colors/backgrounds/default' : _this$props$backgroun,
          children = _this$props.children,
          ids = _this$props.ids,
          designVersion = _this$props.designVersion,
          designContext = _this$props.designContext,
          focusTrapActive = _this$props.focusTrapActive,
          footer = _this$props.footer,
          klarnaLogo = _this$props.klarnaLogo,
          klarnaLogoAccessibilityLabel = _this$props.klarnaLogoAccessibilityLabel,
          shouldTruncateTitle = _this$props.shouldTruncateTitle,
          hideIntermediatePreRender = _this$props.hideIntermediatePreRender,
          isNonStickyIfShortEnough = _this$props.isNonStickyIfShortEnough,
          isFullScreen = _this$props.isFullScreen,
          rawMaxheight = _this$props.maxHeight,
          minHeight = _this$props.minHeight,
          MaterializedComponent = _this$props.MaterializedComponent,
          onBack = _this$props.onBack,
          onBackgroundClick = _this$props.onBackgroundClick,
          onClose = _this$props.onClose,
          onKeyDown = _this$props.onKeyDown,
          subtitle = _this$props.subtitle,
          title = _this$props.title,
          rightIconAriaLabel = _this$props.rightIconAriaLabel,
          leftIconAriaLabel = _this$props.leftIconAriaLabel,
          iconSrc = _this$props.iconSrc,
          useWindowHeight = _this$props.useWindowHeight,
          leftSidebar = _this$props.leftSidebar,
          leftSidebarWidth = _this$props.leftSidebarWidth,
          _this$props$narrowScr = _this$props.narrowScreenBreakpoint,
          narrowScreenBreakpoint = _this$props$narrowScr === void 0 ? Breakpoints.NARROW_MAX_WIDTH : _this$props$narrowScr,
          large = _this$props.large,
          areButtonsHorizontal = _this$props.areButtonsHorizontal,
          isContentVerticallyCentered = _this$props.isContentVerticallyCentered,
          focusTrapOptions = _this$props.focusTrapOptions,
          onOuterWrapperRef = _this$props.onOuterWrapperRef,
          UNSAFE_containerProps = _this$props.UNSAFE_containerProps;
      var maxHeight = rawMaxheight && (isNaN(rawMaxheight) ? rawMaxheight : "".concat(rawMaxheight, "px"));
      var _this$state = this.state,
          bottomSize = _this$state.bottomSize,
          contentSize = _this$state.contentSize,
          rootSize = _this$state.rootSize;
      var isMobile = rootSize.width <= Breakpoints.MOBILE_MAX_WIDTH || rootSize.height < Breakpoints.DESKTOP_MIN_HEIGHT;
      var isNarrow = isMobile || rootSize.width <= narrowScreenBreakpoint;
      var hasIconInNavbar = Boolean(iconSrc) && !isMobile && !isFullScreen;
      var navBarHeight = getNavBarHeight(hasIconInNavbar, Boolean(title), this.props.hideHeader);
      var shouldScroll = contentSize.height + EXTRA_PADDINGS + navBarHeight + bottomSize.height > rootSize.height;
      var hasLeftSidebar = leftSidebar && leftSidebar.length && !isMobileDevice() && !isNarrow;

      var _getDefaultStyleSheet = getDefaultStyleSheet({
        areButtonsHorizontal: areButtonsHorizontal,
        backgroundColorToken: backgroundColorToken,
        designVersion: designVersion,
        designContext: designContext,
        isFullScreen: isFullScreen,
        isMobile: isMobile,
        isNarrow: isNarrow,
        isNonStickyIfShortEnough: isNonStickyIfShortEnough,
        shouldScroll: shouldScroll,
        hasLeftSidebar: hasLeftSidebar,
        leftSidebarWidth: leftSidebarWidth,
        rootSize: rootSize,
        contentSize: contentSize,
        maxHeight: maxHeight,
        minHeight: minHeight,
        bottomSize: bottomSize,
        navBarHeight: navBarHeight,
        large: large,
        isContentVerticallyCentered: isContentVerticallyCentered
      }),
          backgroundClickHandlerStyle = _getDefaultStyleSheet.backgroundClickHandlerStyle,
          bottomStyle = _getDefaultStyleSheet.bottomStyle,
          containerStyle = _getDefaultStyleSheet.containerStyle,
          containerWrapperStyle = _getDefaultStyleSheet.containerWrapperStyle,
          containerWrapperColumnsStyle = _getDefaultStyleSheet.containerWrapperColumnsStyle,
          contentStyle = _getDefaultStyleSheet.contentStyle,
          sidebarWrapperStyle = _getDefaultStyleSheet.sidebarWrapperStyle,
          outerWrapperStyle = _getDefaultStyleSheet.outerWrapperStyle,
          innerWrapperStyle = _getDefaultStyleSheet.innerWrapperStyle,
          navBarWrapperStyle = _getDefaultStyleSheet.navBarWrapperStyle,
          rootStyle = _getDefaultStyleSheet.rootStyle,
          scrollableAreaStyle = _getDefaultStyleSheet.scrollableAreaStyle,
          dialogIconContainer = _getDefaultStyleSheet.dialogIconContainer,
          dialogIconInlineContainer = _getDefaultStyleSheet.dialogIconInlineContainer,
          footerButtonsWrapperStyle = _getDefaultStyleSheet.footerButtonsWrapperStyle,
          buttonWrapperStyle = _getDefaultStyleSheet.buttonWrapperStyle; // `.matches` is used inside `tabbable` (`focus-trap` dependency (IE11))


      if (focusTrapActive && !Element.prototype.matches) {
        Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector || function () {};
      }

      var dialogContentWidth = isMobile || isFullScreen ? rootSize.width - 40 : getDesktopContentSize(large, isNarrow) - 100;
      var content = /*#__PURE__*/React.createElement(Layout, _extends({}, UNSAFE_containerProps, {
        id: ids.root,
        style: rootStyle,
        onResize: useWindowHeight ? undefined : this.onRootResize,
        tabIndex: "0",
        onKeyDown: onKeyDown
      }), function () {
        var ContainerLayout = function ContainerLayout() {
          return /*#__PURE__*/React.createElement(View, {
            style: contentStyle,
            onRef: function onRef(contentDomElement) {
              _this2.contentDomElement = contentDomElement;
              _this2.contentDomElementDefaultView = _this2.contentDomElement && _this2.contentDomElement.ownerDocument && _this2.contentDomElement.ownerDocument.defaultView;

              if (contentDomElement) {
                _this2.rootDomElement = contentDomElement.parentNode.parentNode.parentNode.parentNode;

                if (useWindowHeight) {
                  _this2.calculateWindowAndResize();
                }
              }
            }
          }, /*#__PURE__*/React.createElement(Entanglement, {
            adapter: _this2.adapter
          }, iconSrc && (isMobile || isFullScreen) ? /*#__PURE__*/React.createElement(View, {
            style: dialogIconInlineContainer
          }, /*#__PURE__*/React.createElement(DialogIcon, {
            size: DESKTOP_ICON_SIZE,
            source: iconSrc,
            hasBorderTop: isMobile || isFullScreen
          })) : null, hideIntermediatePreRender && (!rootSize.width || !rootSize.height) ? null : children));
        };

        return /*#__PURE__*/React.createElement(TrapFocus, _extends({
          active: focusTrapActive
        }, focusTrapActive ? {
          focusTrapOptions: focusTrapOptions
        } : {}), /*#__PURE__*/React.createElement("div", {
          id: ids.outerWrapper,
          style: outerWrapperStyle,
          ref: onOuterWrapperRef
        }, /*#__PURE__*/React.createElement(View, {
          id: ids.innerWrapper,
          style: innerWrapperStyle
        }, _this2.props.hideHeader ? undefined : /*#__PURE__*/React.createElement(View, {
          id: ids.navBarWrapper,
          style: navBarWrapperStyle
        }, /*#__PURE__*/React.createElement(NavBar, {
          id: ids.navBar,
          height: iconSrc ? navBarHeight : undefined,
          alignTitle: hasIconInNavbar ? 'flex-end' : 'center',
          backgroundColorToken: !isMobile && !isFullScreen && !shouldScroll ? 'colors/backgrounds/transparent' : backgroundColorToken,
          iconBackgroundColorToken: "colors/backgrounds/transparent",
          leftIcon: onBack && IconBackNavigation,
          onLeftClick: onBack,
          leftIconAriaLabel: leftIconAriaLabel,
          title: title,
          hasIcon: hasIconInNavbar,
          shouldTruncateTitle: shouldTruncateTitle,
          subtitle: subtitle,
          klarnaLogo: klarnaLogo,
          klarnaLogoAccessibilityLabel: klarnaLogoAccessibilityLabel,
          rightIcon: onClose && IconClose,
          onRightClick: onClose,
          rightIconAriaLabel: rightIconAriaLabel
        })), /*#__PURE__*/React.createElement(View, {
          id: ids.scrollableArea,
          style: scrollableAreaStyle
        }, onBackgroundClick && /*#__PURE__*/React.createElement(View, {
          id: ids.backgroundClickHandler,
          style: backgroundClickHandlerStyle,
          onClick: onBackgroundClick
        }), iconSrc && !isMobile && !isFullScreen ? /*#__PURE__*/React.createElement(View, {
          style: dialogIconContainer
        }, /*#__PURE__*/React.createElement(DialogIcon, {
          size: DESKTOP_ICON_SIZE,
          source: iconSrc,
          hasBorderTop: isMobile || isFullScreen
        })) : null, /*#__PURE__*/React.createElement(View, {
          id: ids.containerWrapper,
          style: containerWrapperStyle
        }, hasLeftSidebar ? /*#__PURE__*/React.createElement(View, {
          style: containerWrapperColumnsStyle
        }, /*#__PURE__*/React.createElement(View, {
          style: sidebarWrapperStyle
        }, leftSidebar && leftSidebar.map(function (_ref3, index) {
          var Component = _ref3.Component,
              props = _ref3.props;
          return /*#__PURE__*/React.createElement(Component, _extends({
            key: index
          }, props));
        })), /*#__PURE__*/React.createElement(Layout, {
          id: ids.container,
          style: containerStyle,
          onResize: _this2.onContentResize
        }, ContainerLayout)) : /*#__PURE__*/React.createElement(Layout, {
          id: ids.container,
          style: containerStyle,
          onResize: _this2.onContentResize
        }, ContainerLayout))), /*#__PURE__*/React.createElement(View, {
          id: ids.bottom,
          style: bottomStyle,
          onRef: function onRef(bottomDomElement) {
            _this2.bottomDomElement = bottomDomElement;

            if (bottomDomElement) {
              if (useWindowHeight) {
                _this2.calculateWindowAndResize();
              }
            }
          }
        }, /*#__PURE__*/React.createElement(Entanglement, {
          adapter: _this2.adapter
        }, MaterializedComponent && /*#__PURE__*/React.createElement(MaterializedComponent, null), /*#__PURE__*/React.createElement(MaterializedButtonPrimary, null), /*#__PURE__*/React.createElement(MaterializedButtonSecondary, null), /*#__PURE__*/React.createElement(MaterializedButtonTertiary, null), /*#__PURE__*/React.createElement(MaterializedButtonQuaternary, null)), footer && footer.length !== 0 && /*#__PURE__*/React.createElement(React.Fragment, null, footer.map(function (_ref4, index) {
          var Component = _ref4.Component,
              props = _ref4.props;

          if (Component.displayName !== ButtonPrimary.displayName && Component.displayName !== ButtonSecondary.displayName && Component.displayName !== ButtonTertiary.displayName && Component.displayName !== ButtonQuaternary.displayName) {
            return /*#__PURE__*/React.createElement(Component, _extends({
              key: index
            }, props));
          }
        }), /*#__PURE__*/React.createElement(View, {
          id: ids.footerButtonWrapper,
          style: footerButtonsWrapperStyle
        }, footer.map(function (_ref5, index) {
          var Component = _ref5.Component,
              props = _ref5.props;

          if (Component.displayName === ButtonPrimary.displayName || Component.displayName === ButtonSecondary.displayName || Component.displayName === ButtonTertiary.displayName || Component.displayName === ButtonQuaternary.displayName) {
            var finalProps = _objectSpread(_objectSpread({}, props), {}, {
              sticky: props.sticky !== undefined ? false : undefined,
              mobile: props.mobile !== undefined ? false : undefined
            });

            return /*#__PURE__*/React.createElement(View, {
              key: index,
              style: buttonWrapperStyle(index === footer.length - 1)
            }, /*#__PURE__*/React.createElement(Component, finalProps));
          }
        })))))));
      });
      return /*#__PURE__*/React.createElement(DialogContentWidthProvider, {
        value: dialogContentWidth
      }, content);
    }
  }]);

  return Dialog;
}(Component);

export default compose(setDisplayName('DialogUnwrapped'), defaultProps({
  focusTrapActive: false,
  klarnaLogo: false,
  shouldTruncateTitle: false,
  focusTrapOptions: {}
}), withDialogOptions, withHandlers({
  onKeyDown: function onKeyDown(_ref6) {
    var captureEscapeKey = _ref6.captureEscapeKey,
        onClose = _ref6.onClose;
    return function (_ref7) {
      var key = _ref7.key;
      captureEscapeKey && key === 'Escape' && onClose && onClose();
    };
  }
}), withProps(getIds), withDesignVersion, withDesignContext(defaultDesignTokens), omitProps('captureEscapeKey'))(Dialog);
//# sourceMappingURL=index.js.map